import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { Observable } from "rxjs/Observable";

import { RouteOptions } from "../models/route-options";
import { SubscriptionsService } from "./subscriptions.service";
import { Subscription } from "./models/subscription";

import { PermissionsService } from '../shared/services/permissions.service';
import { AllPermissions } from '../models/permissions';

@Component({
  selector: "app-subscription-detail",
  templateUrl: "./subscription-detail.component.html",
  styleUrls: ["./subscription-list.component.less"],
})
export class SubscriptionDetailComponent implements OnInit {
  private _baseLinks : RouteOptions[] = [
    { ref: ["settings"], title: "Settings" },
    { ref: ["users"], title: "Users" },
    { ref: ["invoices"], title: "Invoices" },
    { ref: ["teams"], title: "Private Teams" },
    { ref: ["history"], title: "History" },
  ];
  public sub: Subscription = null;
  public links: RouteOptions[] = [];

  constructor(
    private api: SubscriptionsService,
    private route: ActivatedRoute,
    private permissionsService: PermissionsService,
  ) {
    const permissionsObservable = permissionsService.retrievePermissions();
    const fork = Observable.combineLatest(this.route.params, permissionsObservable);
    fork.subscribe(([params, permissions]: [Params, AllPermissions]) => {
      this.links = [...this._baseLinks];
      let subscriptionId = params["id"];
      this.api
        .getSubscription(subscriptionId)
        .subscribe((subscription) => (this.sub = subscription));
      this.links.push({
        ref: ["/analytics", "subscriptions", subscriptionId, "users"],
        title: "Analytics",
      });

      if (!permissions.manageSubscriptions) {
        // remove all but users and analytics
        this.links = this.links.filter(
          (link: RouteOptions) => ['users', '/analytics'].indexOf(link.ref[0]) > -1
        );
      };
    });
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/subscriptions/subscription-detail.component.ts